export default __webpack_public_path__ + "static/media/text-block-thumbnail-light.f604ea4a.svg";